import { gql } from '@efficiently/client-core-graphql-models';

export const GET_CONTENT_CROPPER_BY_URL = gql(`
	query GetContentCropperByUrl($url: String!) {
		contentCropperByUrl(url: $url) {
			content {
				...ContentDomainContentFields
			}
			cropper {
				...ContentCropperFields
			}
		}
	}
`);
